{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "loading": "Loading...",
    "saving": "Saving...",
    "error": "Error",
    "success": "Success",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "continue": "Continue",
    "close": "Close",
    "search": "Search",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "retry": "Retry",
    "more": "More",
    "remove": "Remove",
    "rename": "Rename",
    "discard": "Discard",
    "submit": "Submit",
    "send": "Send",
    "copy": "Copy",
    "copied": "Copied",
    "settings": "Settings",
    "or": "or",
    "and": "and",
    "untitled": "Untitled",
    "anonymous": "Anonymous",
    "required": "Required",
    "optional": "Optional"
  },
  "nav": {
    "dashboard": "Dashboard",
    "tasks": "Tasks",
    "apps": "Apps",
    "chats": "Chats",
    "users": "Users",
    "settings": "Settings",
    "general": "General",
    "pages": "Pages",
    "other": "Other"
  },
  "auth": {
    "signIn": "Sign In",
    "signOut": "Sign Out",
    "signUp": "Sign Up",
    "forgotPassword": "Forgot Password",
    "email": "Email",
    "emailPlaceholder": "you@company.com",
    "password": "Password",
    "rememberMe": "Remember me",
    "welcomeBack": "Welcome back",
    "signInToAccount": "Sign in to your Glyde account",
    "continueWithGoogle": "Continue with Google",
    "continueWithGithub": "Continue with GitHub",
    "noAccount": "Don't have an account?",
    "alreadyHaveAccount": "Already have an account?",
    "enterVerificationCode": "Enter verification code",
    "verifyEmailTitle": "Verify your email",
    "verifyEmailSubtitle": "Enter the code we sent to {{email}}",
    "verificationCodeLabel": "Verification Code",
    "verifying": "Verifying...",
    "verificationCodeSent": "We sent a 6-digit code to <strong>{{email}}</strong>",
    "verifyAndSignIn": "Verify & Sign In",
    "resendCode": "Resend code",
    "changeEmail": "Change email",
    "checkingAuthentication": "Checking authentication...",
    "emailRequired": "Please enter your email address",
    "emailInvalid": "Please enter a valid email address",
    "codeRequired": "Please enter the 6-digit code",
    "emailVerified": "Email verified! Please log in to continue.",
    "signedInSuccess": "Signed in successfully!",
    "twoFactorRequired": "Two-factor authentication required.",
    "codeSent": "Code sent!",
    "codeResent": "Code resent!",
    "resendFailed": "Failed to resend code",
    "verificationFailed": "Verification failed: {{message}}",
    "failedSendCode": "Failed to send code",
    "noAccountFound": "No account found for this email. Please sign up first.",
    "otpExpired": "Verification code has expired. Please request a new one.",
    "invalidOtp": "Invalid verification code. Please try again.",
    "tooManyAttempts": "Too many attempts. Please try again later.",
    "signInFailed": "Failed to sign in. Please try again.",
    "authTimedOut": "Authentication timed out. Please try again.",
    "sessionCouldNotEstablish": "Sign-in succeeded but session could not be established. Please try again.",
    "forgotPasswordTitle": "Forgot your password?",
    "forgotPasswordDescription": "Enter your email and we'll send you a link to reset your password.",
    "resetPassword": "Reset password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "signUpTitle": "Create your account",
    "signUpDescription": "Get started with Glyde for free.",
    "name": "Name",
    "namePlaceholder": "Your name",
    "agreeTerms": "By signing up, you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>."
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "profile": "Profile",
    "workspace": "Workspace",
    "language": "Language",
    "languageDescription": "Choose the language for the interface.",
    "theme": "Theme",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "System",
    "deleteWorkspace": "Delete Workspace",
    "workspaceName": "Workspace name",
    "taskCodePrefix": "Task code prefix",
    "taskCodePrefixDescription": "Set a custom prefix for task codes. Task codes are displayed as {{prefix}}-1, {{prefix}}-2, etc. Leave empty to use the default prefix derived from your workspace name.",
    "taskCodePrefixDefault": "Default: {{prefix}} (from workspace name)",
    "taskCodePrefixLabel": "Prefix",
    "taskCodePrefixPreview": "Preview:",
    "saveTaskCodePrefix": "Save Prefix",
    "taskCodePrefixUpdated": "Task code prefix updated successfully",
    "taskCodePrefixFailed": "Failed to update task code prefix",
    "workspaceDescription": "A workspace helps you organize your documentation.",
    "members": "Members",
    "billing": "Billing",
    "security": "Security",
    "apiKeys": "API keys",
    "integrations": "Integrations",
    "auditLogs": "Audit logs",
    "profileDescription": "Manage your profile information.",
    "displayName": "Display name",
    "avatar": "Avatar",
    "uploadAvatar": "Upload avatar",
    "removeAvatar": "Remove avatar"
  },
  "workspace": {
    "switch": "Switch workspace",
    "create": "Create workspace",
    "name": "Name",
    "description": "Description"
  },
  "topics": {
    "addTopic": "Add Topic",
    "newTopic": "New topic",
    "topicTitle": "Topic title",
    "topicTitlePlaceholder": "Enter topic title",
    "deleteTopic": "Delete topic",
    "deleteTopicConfirm": "Are you sure you want to delete this topic?",
    "deleteTopicWarning": "This action cannot be undone. This will permanently delete the topic and all its content.",
    "topicCreated": "Topic created successfully",
    "topicDeleted": "Topic deleted successfully",
    "topicCreateFailed": "Failed to create topic",
    "topicDeleteFailed": "Failed to delete topic",
    "emptyTopicTitle": "No topics yet",
    "emptyTopicDescription": "Create your first topic to start organizing your documentation.",
    "createFirstTopic": "Create your first topic",
    "emptySectionTitle": "Empty section",
    "emptySectionDescription": "Add content to this section or create a sub-topic.",
    "deleteConfirm": "Are you sure you want to delete \"{{title}}\"?",
    "deleteWithSubtopics": "Warning: This will also delete {{count}} subtopic.",
    "deleteWithSubtopics_plural": "Warning: This will also delete {{count}} subtopics.",
    "deleting": "Deleting...",
    "unableToDelete": "Unable to delete topic",
    "deleteFailed": "Failed to delete topic: {{message}}",
    "addToSection": "Add to {{section}}",
    "addToChangelog": "Add to {{section}} Changelog",
    "addToApi": "Add to {{section}} API",
    "navCreate": "Create",
    "navCreateDesc": "Create new topic or use template",
    "navRecording": "Recording",
    "navRecordingDesc": "Create from screen recording",
    "navImportOpenApi": "OpenAPI/Swagger",
    "navImportOpenApiDesc": "Import API documentation",
    "navImportFromSources": "Import from Sources",
    "navImportFromSourcesDesc": "Import from a connected source",
    "navSupportTickets": "Support Tickets",
    "navSupportTicketsDesc": "Create from support tickets",
    "navChangelogCreate": "Create",
    "navChangelogCreateDesc": "Create new changelog entry or topic",
    "navImportGitHub": "Import from GitHub",
    "navImportGitHubDesc": "Import releases from GitHub",
    "navCreateApiDesc": "Create new topic",
    "navImportOpenApiSpec": "Import OpenAPI",
    "navImportOpenApiSpecDesc": "Import API documentation from OpenAPI spec",
    "comingSoon": "Coming Soon"
  },
  "sections": {
    "createFirstSection": "Create Your First Section",
    "configureSection": "Configure Section",
    "chooseTemplate": "Choose a template to organize your documentation",
    "customizeDetails": "Customize your section details",
    "selectTemplate": "Please select a template",
    "sectionTitle": "Section Title",
    "sectionTitlePlaceholder": "Enter section title",
    "sectionTitleDescription": "The main title for your documentation section",
    "urlSlugOptional": "URL Slug (Optional)",
    "urlSlugPlaceholder": "custom-url-slug",
    "urlSlugDescription": "Leave empty to auto-generate from title",
    "change": "Change",
    "createSection": "Create Section",
    "sectionCreated": "Section created successfully",
    "createSectionFailed": "Failed to create section",
    "topicsCreated": "Created {{count}} topic",
    "topicsCreated_plural": "Created {{count}} topics",
    "placeholdersReady": "{{count}} placeholder ready for import",
    "placeholdersReady_plural": "{{count}} placeholders ready for import",
    "templateCreationUnavailable": "Template creation not available, creating regular section"
  },
  "recording": {
    "newRecording": "New recording",
    "startRecording": "Start recording",
    "stopRecording": "Stop recording",
    "pauseRecording": "Pause recording",
    "resumeRecording": "Resume recording",
    "cancelRecording": "Cancel recording",
    "recording": "Recording",
    "paused": "Paused"
  },
  "loading": {
    "page": "Loading page...",
    "content": "Loading content..."
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection.",
    "unauthorized": "You are not authorized to perform this action.",
    "notFound": "Not found.",
    "sessionExpired": "Your session has expired. Please sign in again.",
    "tryAgain": "Please try again.",
    "unknownError": "Unknown error"
  },
  "sidebar": {
    "mySpace": "My Space",
    "workspaces": "Workspaces",
    "team": "Team",
    "integrations": "Integrations",
    "settings": "Settings",
    "newSop": "New SOP",
    "newWorkspace": "New Workspace",
    "newWorkspaceDescription": "Create a workspace to organize your SOPs.",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Product Docs",
    "descriptionLabel": "Description",
    "descriptionOptional": "(optional)",
    "descriptionPlaceholder": "What is this workspace for?",
    "colorLabel": "Color",
    "creating": "Creating..."
  },
  "dashboard": {
    "mySpace": "My Space",
    "dashboard": "Dashboard",
    "subtitle": "Your SOPs across all workspaces.",
    "importVideo": "Import Video",
    "newSop": "New SOP",
    "sops": "SOPs",
    "workspace": "Workspace",
    "workspaces": "Workspaces",
    "shared": "Shared",
    "tabAll": "All",
    "tabMine": "My SOPs",
    "tabShared": "Shared with Me",
    "searchPlaceholder": "Search SOPs...",
    "emptyTitle": "No SOPs yet",
    "emptyMine": "Create your first SOP by recording your screen or importing a video.",
    "emptyShared": "No SOPs have been shared with you yet.",
    "emptyAll": "No SOPs across your workspaces.",
    "getExtension": "Get the Extension",
    "recordScreen": "Record Screen",
    "getExtensionDescription": "Install the Chrome extension to start recording.",
    "recordScreenDescription": "Record your screen to generate an SOP automatically.",
    "installExtension": "Install Extension",
    "newRecording": "New Recording",
    "importVideoCardTitle": "Import Video",
    "importVideoCardDescription": "Upload an existing video to turn it into an SOP.",
    "addIntegrationsTitle": "Add Integrations",
    "addIntegrationsDescription": "Our integrations include Notion, Confluence, Google Drive.",
    "viewIntegrations": "View Integrations",
    "tableTitle": "Title",
    "tableApplication": "Application",
    "tableWorkspace": "Workspace",
    "tableCreatedBy": "Created By",
    "tableLastModified": "Last Modified",
    "tableAction": "Action",
    "loadingSops": "Loading SOPs...",
    "noSopsFound": "No SOPs found",
    "tryAdjustingSearch": "Try adjusting your search terms.",
    "untitledSop": "Untitled SOP",
    "addToWorkspace": "Add to Workspace",
    "delete": "Delete",
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{total}}",
    "deleteSopTitle": "Delete SOP",
    "deleteSopDesc": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
    "sopDeleted": "SOP deleted",
    "sopDeleteFailed": "Failed to delete SOP: {{error}}",
    "upgradeFeatureName": "Add to Workspace",
    "upgradeFeatureDescription": "Share SOPs across multiple workspaces to keep your team aligned.",
    "upgradeBenefit1": "Share SOPs to any workspace",
    "upgradeBenefit2": "Unlimited workspaces",
    "upgradeBenefit3": "Cross-team collaboration"
  },
  "team": {
    "title": "Team",
    "subtitle": "Manage team members and their roles.",
    "searchPlaceholder": "Search team...",
    "invite": "Invite",
    "noPermissionInvite": "You don't have permission to invite members",
    "invitationSent": "Invitation sent successfully",
    "invitationFailed": "Failed to send invitation: {{error}}",
    "referralSent": "Referral sent to {{email}}",
    "referralFailed": "Failed to send referral",
    "defaultInviteMessage": "Hey, I'm using {{appName}} to turn screen recordings into polished SOPs with AI. Join the workspace so we can build and share documentation together.",
    "referTitle": "Refer a teammate",
    "referDescription": "They'll get their own free workspace with {{appName}}.",
    "referCollaborateQuestion": "Want to collaborate in the same workspace?",
    "referUpgradeButton": "Upgrade to Pro",
    "sendReferral": "Send referral",
    "sendingReferral": "Sending...",
    "inviteTitle": "Invite team member",
    "inviteDescription": "Send an invitation to join your workspace",
    "emailLabel": "Email address",
    "emailPlaceholder": "colleague@company.com",
    "roleLabel": "Role",
    "selectRole": "Select a role",
    "roleMemberOption": "Member - Can edit content",
    "roleAdminOption": "Admin - Can manage members",
    "roleAdminHint": "Admins can manage members and workspace settings",
    "roleMemberHint": "Members can create, edit, and publish SOPs",
    "personalNote": "Personal note",
    "personalNoteOptional": "Personal note (optional)",
    "personalNotePlaceholder": "Add a personal message to the invitation...",
    "referralNotePlaceholder": "Hey, you should try this for SOPs and docs...",
    "sendInvite": "Send Invite",
    "sendingInvite": "Sending...",
    "upgradeFeatureName": "Team Collaboration",
    "upgradeFeatureDescription": "Invite team members to collaborate on guides and SOPs together.",
    "upgradeBenefit1": "Invite unlimited team members",
    "upgradeBenefit2": "Assign roles and permissions",
    "upgradeBenefit3": "Collaborate on guides in real time"
  },
  "upgradeDialog": {
    "title": "Upgrade to Pro",
    "unlockFeature": "Unlock {{feature}} and other advanced features with a Pro plan.",
    "unlockGeneric": "Unlock advanced features with a Pro plan.",
    "cta": "Upgrade to Pro",
    "learnMore": "Learn more about plans"
  },
  "integrations": {
    "title": "Integrations",
    "subtitle": "Connect your favorite tools to import and export content.",
    "tabAvailable": "Available Integrations",
    "tabConnected": "Connected Integrations",
    "loadingAvailable": "Loading integrations...",
    "loadingConnected": "Loading connected integrations...",
    "noActiveIntegrations": "No active integrations. Connect an integration from the Available tab.",
    "removeIntegrationTitle": "Remove Integration",
    "removeIntegrationDescription": "Are you sure you want to remove this integration? This action cannot be undone.",
    "removeButton": "Remove",
    "removedSuccess": "Integration removed successfully",
    "publishToZendesk": "Publish to Zendesk",
    "noProviderFound": "No provider found for integration",
    "upgradeToPro": "Upgrade to Pro",
    "comingSoon": "Coming Soon",
    "connect": "Connect",
    "manage": "Manage",
    "upgradeFeatureName": "Third-party Integrations",
    "upgradeFeatureDescription": "Connect your documentation with popular third-party platforms",
    "upgradeBenefit1": "Export SOPs to Notion, Google Docs, and Confluence",
    "upgradeBenefit2": "Sync data across multiple platforms",
    "upgradeBenefit3": "Easily manage integrations from one place"
  },
  "settingsLayout": {
    "title": "Settings",
    "subtitle": "Manage your workspace and account preferences."
  },
  "settingsNav": {
    "organization": "Organization",
    "compliance": "Compliance",
    "writing": "Writing",
    "apiKeys": "API Keys",
    "billing": "Billing",
    "signing": "Signing",
    "profile": "Profile",
    "security": "Security",
    "general": "General",
    "publishing": "Publishing",
    "properties": "Properties",
    "members": "Members",
    "auditLogs": "Audit Logs",
    "mcpServer": "MCP Server",
    "branding": "Branding",
    "templates": "Style",
    "themeSelect": "Theme"
  },
  "security": {
    "title": "Security",
    "subtitle": "Manage your account security settings.",
    "twoFactorTitle": "Two-Factor Authentication",
    "twoFactorBlurb": "Add an extra layer of security to your account using an authenticator app.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "twoFactorEnabledNote": "Your account is protected with two-factor authentication.",
    "twoFactorDisabledNote": "Two-factor authentication adds an extra layer of security by requiring a code from your authenticator app when signing in.",
    "enableTwoFactor": "Enable Two-Factor Authentication",
    "disableTwoFactor": "Disable 2FA",
    "disableTwoFactorToast": "Two-factor authentication disabled",
    "enableTwoFactorTitle": "Enable Two-Factor Authentication",
    "enablePasswordDescription": "Enter your password to continue setting up two-factor authentication.",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter your password",
    "forgotPassword": "Forgot password?",
    "continue": "Continue",
    "scanQRTitle": "Scan QR Code",
    "scanQRDescription": "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
    "manualEntryCode": "Manual entry code",
    "manualEntryHint": "If you can't scan the QR code, enter this code manually in your authenticator app.",
    "nextVerify": "Next: Verify Code",
    "verifySetupTitle": "Verify Setup",
    "verifySetupDescription": "Enter the 6-digit code from your authenticator app to verify setup.",
    "back": "Back",
    "verifyEnable": "Verify & Enable",
    "saveBackupTitle": "Save Your Backup Codes",
    "saveBackupDescription": "Keep these codes safe. You can use them to access your account if you lose your authenticator device. Each code can only be used once.",
    "clickToCopy": "Click to copy",
    "copyAll": "Copy All",
    "download": "Download",
    "savedCodes": "I've saved these codes",
    "verifyIdentityTitle": "Verify Your Identity",
    "verifyIdentityDescription": "For security, please enter the code from your authenticator app to continue.",
    "verifyContinue": "Verify & Continue",
    "confirmDisableTitle": "Confirm Disable 2FA",
    "confirmDisableDescription": "Enter your password to confirm disabling two-factor authentication.",
    "resetPasswordTitle": "Reset Your Password",
    "resetPasswordDescription": "We sent a verification code to {{email}}. Enter the code and your new password below.",
    "verificationCode": "Verification Code",
    "newPassword": "New Password",
    "newPasswordPlaceholder": "Enter new password (min 8 characters)",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "resendCode": "Resend code",
    "resetPassword": "Reset Password",
    "verificationCodeSentToast": "Verification code sent to your email",
    "passwordResetToast": "Password reset successfully!",
    "noEmailError": "No email address found for your account",
    "failedToSendCode": "Failed to send verification code",
    "failedToResetPassword": "Failed to reset password",
    "failedEnableTwoFactor": "Failed to enable two-factor authentication",
    "failedDisableTwoFactor": "Failed to disable two-factor authentication",
    "invalidVerificationCode": "Invalid verification code",
    "pleaseEnter6Digit": "Please enter the 6-digit code",
    "passwordMinLength": "Password must be at least 8 characters",
    "passwordsDoNotMatch": "Passwords do not match",
    "genericError": "An error occurred. Please try again.",
    "noCodeToCopy": "No code available to copy",
    "copiedToClipboard": "Copied to clipboard",
    "backupCodesDownloaded": "Backup codes downloaded",
    "changePasswordTitle": "Change Password",
    "changePasswordSubtitle": "Update your account password.",
    "currentPasswordLabel": "Current Password",
    "currentPasswordPlaceholder": "Enter current password",
    "newPasswordLabel": "New Password",
    "confirmNewPasswordLabel": "Confirm New Password",
    "changePasswordButton": "Change Password",
    "enterCurrentPasswordError": "Please enter your current password",
    "newPasswordMinError": "New password must be at least 8 characters",
    "passwordChangedToast": "Password changed successfully",
    "failedChangePassword": "Failed to change password"
  },
  "workspaceView": {
    "addSop": "Add SOP",
    "tabSops": "SOPs",
    "tabMembers": "Members",
    "tabSettings": "Settings",
    "sopsCount_one": "{{count}} SOP",
    "sopsCount_other": "{{count}} SOPs",
    "search": "Search...",
    "colName": "Name",
    "colApplication": "Application",
    "colSteps": "Steps",
    "colCreatedBy": "Created by",
    "colAction": "Action",
    "loadingSops": "Loading SOPs...",
    "noSopsFound": "No SOPs found",
    "tryDifferentSearch": "Try a different search term.",
    "startRecordingHint": "Start a screen recording to create your first SOP.",
    "untitledSop": "Untitled SOP",
    "sopDeleted": "SOP deleted",
    "sopDeleteFailed": "Failed to delete SOP: {{error}}",
    "sopRemoved": "SOP removed from workspace",
    "sopRemoveFailed": "Failed to remove SOP: {{error}}",
    "removeFromWorkspaceTitle": "Remove from Workspace",
    "removeFromWorkspaceDesc": "This will remove \"{{title}}\" from this workspace. The original SOP will not be deleted.",
    "deleteSopTitle": "Delete SOP",
    "deleteSopDesc": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
    "remove": "Remove",
    "membersCount_one": "{{count}} member",
    "membersCount_other": "{{count}} members",
    "pendingCount": "· {{count}} pending",
    "inviteMember": "Invite Member",
    "noPermissionInviteMembers": "You don't have permission to invite members",
    "inviteMemberTitle": "Invite member",
    "inviteMemberDesc": "Invite a new member to this workspace",
    "emailAddress": "Email address",
    "enterEmailAddress": "Enter email address",
    "role": "Role",
    "selectRole": "Select a role",
    "roleAdmin": "Admin",
    "roleAdminDesc": "Full access to manage workspace",
    "roleCollaborator": "Collaborator",
    "roleCollaboratorDesc": "Can edit and review content",
    "sendInvite": "Send invite",
    "sending": "Sending...",
    "colMember": "MEMBER",
    "colRole": "ROLE",
    "colStatus": "STATUS",
    "loadingMembers": "Loading members...",
    "noMembersYet": "No members yet",
    "inviteTeamHint": "Invite team members to collaborate on SOPs.",
    "statusPending": "Pending",
    "statusActive": "Active",
    "roleOwner": "Owner",
    "invitationSent": "Invitation sent successfully",
    "invitationFailed": "Failed to send invitation: {{error}}",
    "removeMemberTitle": "Remove Member",
    "removeMemberDesc": "Are you sure you want to remove \"{{name}}\" from this workspace?",
    "roleUpdated": "Role updated",
    "failedUpdateRole": "Failed to update role",
    "memberRemoved": "Member removed",
    "failedRemoveMember": "Failed to remove member",
    "settingsGeneral": "General",
    "workspaceName": "WORKSPACE NAME",
    "description": "DESCRIPTION",
    "color": "COLOR",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "workspaceUpdated": "Workspace updated",
    "workspaceUpdateFailed": "Failed to update workspace: {{error}}"
  },
  "signup": {
    "title": "Create your account",
    "subtitle": "Start creating amazing documentation in minutes",
    "continueWithGoogle": "Continue with Google",
    "continueWithGithub": "Continue with GitHub",
    "or": "or",
    "fullNameLabel": "Full Name",
    "fullNamePlaceholder": "Jane Smith",
    "emailLabel": "Email",
    "emailPlaceholder": "name@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "At least 8 characters",
    "agreeTerms": "I agree to the",
    "termsOfService": "Terms of Service",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "createAccount": "Create Account",
    "creatingAccount": "Creating account...",
    "alreadyHaveAccount": "Already have an account?",
    "signIn": "Sign in",
    "errorEnterName": "Please enter your name",
    "errorNameTooLong": "Name is too long",
    "errorEnterEmail": "Please enter your email",
    "errorInvalidEmail": "Invalid email address",
    "errorPasswordMin": "Password must be at least 8 characters",
    "errorMustAgreeTerms": "You must agree to the terms",
    "accountCreated": "Account created! Please verify your email.",
    "verificationCodeSent": "We sent a verification code to {{email}}",
    "failedCreateAccount": "Failed to create account",
    "failedCreateAccountRetry": "Failed to create account. Please try again.",
    "cannotSignupWith": "Cannot sign up with {{provider}}: {{error}}"
  },
  "loginLayout": {
    "tagline": "Turn any workflow into a living guide.",
    "description": "Record your screen or import a Loom. Glyde turns it into a step-by-step guide your team can follow — or walk through live in their browser.",
    "stat1Label": "SOPs Generated",
    "stat2Label": "Teams Active",
    "stat3Label": "Time Saved",
    "stat4Label": "Average Rating"
  },
  "membersTable": {
    "colUser": "User",
    "colRole": "Role",
    "colStatus": "Status",
    "colDateJoined": "Date joined",
    "colActions": "Actions",
    "statusActive": "Active",
    "statusPending": "Pending",
    "roleOwner": "Owner",
    "roleAdmin": "Admin",
    "roleMember": "Member",
    "roleCollaborator": "Collaborator",
    "roleViewer": "Viewer",
    "selectRole": "Select role",
    "unnamedUser": "Unnamed User",
    "noMembersMatchSearch": "No members found matching your search.",
    "noMembersFound": "No members found.",
    "cancelInvitationTitle": "Cancel Invitation",
    "cancelInvitationDesc": "Are you sure you want to cancel this invitation?",
    "cancelInvitationConfirm": "Cancel Invitation",
    "invitationCancelled": "Invitation cancelled",
    "failedCancelInvitation": "Failed to cancel invitation",
    "invitationResent": "Invitation resent",
    "failedResendInvitation": "Failed to resend invitation",
    "roleUpdated": "Role updated",
    "failedUpdateRole": "Failed to update role",
    "memberRemoved": "Member removed successfully",
    "failedRemoveMember": "Failed to remove member: {{error}}"
  },
  "profileForm": {
    "profilePicture": "Profile picture",
    "profilePictureHint": "Use a photo or image that is 132px square or larger.",
    "upload": "Upload",
    "remove": "Remove",
    "firstName": "First name",
    "lastName": "Last name",
    "enterFirstName": "Enter your first name",
    "enterLastName": "Enter your last name",
    "email": "Email",
    "enterEmail": "Enter your email",
    "update": "Update",
    "saving": "Saving...",
    "updatedSuccess": "Updated successfully",
    "failedUpdate": "Failed to update",
    "firstNameRequired": "First name is required",
    "uploadAvatarTitle": "Upload Avatar",
    "uploadAvatarHint": "Use a photo or image that is 132px square or larger.",
    "dragDropAvatar": "Drag & drop a avatar here, or click to select",
    "supportedFormats": "Supported formats: PNG, JPG, JPEG",
    "uploading": "Uploading"
  },
  "writingSettings": {
    "title": "Writing",
    "subtitle": "Customize AI writing settings for your workspace.",
    "guidelinesLabel": "Writing Guidelines",
    "guidelinesPlaceholder": "e.g. \"Technical docs for developers. Concise, no jargon. Use bullet points and code examples.\"",
    "update": "Update",
    "saving": "Saving...",
    "updatedSuccess": "Updated successfully",
    "errorUpdating": "Error updating: {{message}}",
    "errorLoadingWorkspace": "Error loading workspace: {{message}}",
    "workspaceNotFound": "Workspace not found"
  },
  "organizationSettings": {
    "title": "Organization",
    "organizationName": "Organization Name",
    "organizationSlug": "Organization Slug",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "updatedSuccess": "Organization updated successfully",
    "failedUpdate": "Failed to update organization"
  },
  "sopEditor": {
    "guideMe": "Guide Me",
    "edit": "Edit",
    "cancel": "Cancel",
    "save": "Save",
    "share": "Share",
    "delete": "Delete",
    "untitledSop": "Untitled SOP",
    "sops": "SOPs",
    "addToWorkspace": "Add to Workspace",
    "exportToNotion": "Export to Notion",
    "exportToGoogleDocs": "Export to Google Docs",
    "exportToConfluence": "Export to Confluence",
    "deleteSopTitle": "Delete SOP",
    "deleteSopDesc": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
    "upgradeFeatureName": "Add to Workspace",
    "upgradeFeatureDescription": "Share SOPs across multiple workspaces to keep your team aligned.",
    "upgradeBenefit1": "Share SOPs to any workspace",
    "upgradeBenefit2": "Unlimited workspaces",
    "upgradeBenefit3": "Cross-team collaboration",
    "contents": "Contents",
    "details": "Details",
    "category": "Category",
    "created": "Created",
    "createdBy": "Created by",
    "waitingForContent": "Waiting for content...",
    "noHeadingsFound": "No headings found",
    "toolbarImage": "Image",
    "personalSpace": "{{name}}'s Space"
  },
  "errorPages": {
    "pageNotFound": "Page not found",
    "pageNotFoundDesc": "The page you're looking for doesn't exist or has been moved.",
    "accessDenied": "Access denied",
    "accessDeniedDesc": "You don't have permission to access this page. Contact your workspace admin.",
    "goToDashboard": "Go to Dashboard",
    "goBack": "Go Back",
    "somethingWentWrong": "Something went wrong",
    "somethingWentWrongDesc": "We apologize for the inconvenience. Please try again later.",
    "backToHome": "Back to Home"
  },
  "billing": {
    "title": "Billing",
    "subtitle": "Manage your subscription and billing settings.",
    "currentSubscription": "Current Subscription",
    "statusActive": "Active",
    "statusPastDue": "Past Due",
    "statusCanceled": "Canceled",
    "statusPaused": "Paused",
    "nextBillingDate": "Next billing date: {{date}}",
    "billedAnnually": "{{amount}} billed annually",
    "teamSeats": "Team Seats",
    "seat_one": "{{count}} seat",
    "seat_other": "{{count}} seats",
    "manageSeats": "Manage Seats",
    "videoImports": "Video Imports",
    "thisMonth": "this month",
    "unlimited": "Unlimited",
    "monthly": "Monthly",
    "annual": "Annual",
    "save20": "Save 20%",
    "currentPlan": "Current Plan",
    "contactUs": "Contact Us",
    "upgrade": "Upgrade",
    "manageSubscription": "Manage Subscription",
    "subscriptionUpdated": "Subscription updated successfully!",
    "checkoutCanceled": "Checkout was canceled.",
    "perMonth": "/mo",
    "planFreeName": "Free",
    "planProName": "Pro",
    "planEnterpriseName": "Enterprise",
    "planFreeDescription": "25 guides, 1 workspace",
    "planProDescription": "Unlimited guides, team workspaces",
    "planEnterpriseDescription": "SSO, audit logs, API keys",
    "partnerBillingTitle": "Billing & Subscription",
    "partnerBillingSubtitle": "Manage your billing and subscription settings",
    "partnerManagedTitle": "Partner-Managed Billing",
    "partnerManagedDesc1": "Your billing and subscription are managed by your partner organization",
    "partnerManagedDesc2": "To upgrade your plan, increase workspace limits, or modify billing settings, please contact your partner organization directly.",
    "partnerManagedOrgTitle": "Partner-Managed Organization",
    "partnerManagedOrgDesc": "This organization is managed by a partner",
    "partnerOrgLabel": "Partner Organization",
    "partnerOrgFallback": "Partner organization",
    "partnerManagedBadge": "Partner-Managed",
    "partnerManagesList": "Your partner manages:",
    "partnerManagesItem1": "Plan selection and upgrades",
    "partnerManagesItem2": "Billing and payment methods",
    "partnerManagesItem3": "Workspace allocation limits",
    "partnerManagesItem4": "Credit purchases",
    "seatDialog": {
      "title": "Team Seats",
      "currentUsage": "Current Usage",
      "activeMembers": "Active members",
      "currentSeats": "Current seats",
      "seatsIncluded": "Seats included",
      "numberOfSeats": "Number of seats",
      "continueToCheckout": "Continue to Checkout",
      "updateSeats": "Update Seats",
      "updating": "Updating...",
      "redirecting": "Redirecting...",
      "updateSuccess": "Seat count updated successfully",
      "updateError": "Failed to update seat count",
      "firstSeatIncluded": "First seat included in plan",
      "costAdding_one": "Adding {{count}} seat: ${{cost}}/mo prorated",
      "costAdding_other": "Adding {{count}} seats: ${{cost}}/mo prorated",
      "costRemoving_one": "Removing {{count}} seat",
      "costRemoving_other": "Removing {{count}} seats",
      "additionalSeats_one": "{{count}} additional seat: +${{cost}}/mo",
      "additionalSeats_other": "{{count}} additional seats: +${{cost}}/mo"
    }
  },
  "shareDialog": {
    "title": "Share SOP",
    "subtitle": "Control who can access this document",
    "close": "Close",
    "tabShare": "Share",
    "tabEmbed": "Embed",
    "tabExport": "Export",
    "proBadge": "Pro",
    "embedProTitle": "Embed is a Pro feature",
    "embedProHint": "Upgrade to Pro to embed your SOPs in Notion, Confluence, and other platforms.",
    "invite": "Invite",
    "inviteEmailPlaceholder": "Email or group, separate by comma",
    "inviteButton": "Invite",
    "invited": "Invited",
    "invitationSent": "Invitation sent to {{email}}",
    "failedCreateInvitation": "Failed to create invitation.",
    "shareLinkNotReady": "Please wait for the share link to be generated.",
    "documentContextMissing": "Document context missing",
    "shareToWeb": "Share to web",
    "shareToWebEnableHint": "Enable to let anyone with the link view",
    "shareToWebPublicHint": "Anyone with the link can view",
    "publicSharingEnabled": "Public sharing enabled",
    "publicSharingDisabled": "Public sharing disabled",
    "failedUpdateSettings": "Failed to update share settings",
    "shareSettingsUpdated": "Share settings updated",
    "failedUpdatePassword": "Failed to update password",
    "accessPassword": "Access password",
    "optionPublic": "Anyone on the web with link",
    "optionPrivate": "Only people invited",
    "optionEmailDomains": "Only people with {{domain}} email domain",
    "optionPassword": "Only people with password",
    "shareToSocialMedia": "Share to Social Media",
    "facebook": "Facebook",
    "x": "X",
    "linkedin": "LinkedIn",
    "email": "Email",
    "copyLink": "Copy Link",
    "embedDescription": "Embed an interactive version directly into most platforms, where your team already works.",
    "livePreview": "Live preview",
    "greatForKnowledgeBases": "Great for knowledge bases",
    "copyEmbed": "Copy Embed",
    "previewWillAppear": "Preview will appear here",
    "failedGenerateEmbed": "Failed to generate embed preview",
    "generationFailed": "Generation failed",
    "exportToPdf": "Export to PDF",
    "exportToPdfDesc": "Share the PDF with your team or print the PDF.",
    "exportToDocx": "Export to DOCX",
    "exportToDocxDesc": "Works well with Microsoft Word and other office apps.",
    "exportToMarkdown": "Export to Markdown",
    "exportToMarkdownDesc": "Works well with GitHub and other apps.",
    "export": "Export",
    "pdfExported": "PDF exported",
    "docxExported": "DOCX exported!",
    "markdownExported": "Markdown exported!",
    "htmlExported": "HTML exported!",
    "failedExport": "Export failed: {{message}}",
    "failedExportDocx": "Failed to export DOCX: {{message}}",
    "failedExportMarkdown": "Failed to export markdown: {{message}}",
    "failedExportHtml": "Failed to export HTML: {{message}}",
    "failedGetDownloadLink": "Failed to get download link",
    "documentNotFound": "Document not found",
    "noTopicSelected": "No topic selected",
    "noDocumentFound": "No document found for this topic",
    "failedResolveDocument": "Failed to resolve document: {{message}}",
    "unableToShareSop": "Unable to share SOP, please ensure the SOP is loaded",
    "unableToShareDoc": "Unable to share document, please ensure the document is loaded",
    "unableToGetDocId": "Unable to get document ID, please ensure the document is loaded",
    "failedGenerateSopLink": "Failed to generate SOP share link, please try again",
    "failedGenerateShareLink": "Failed to generate share link, please try again",
    "pleaseGenerateLinkFirst": "please generate share link first"
  },
  "importVideo": {
    "title": "Import Video to SOP",
    "description": "Upload a screen recording to automatically generate a Standard Operating Procedure. You'll receive an email when it's ready.",
    "dropHint": "Drop video file here or click to browse",
    "supports": "Supports MP4, WebM, MOV (max 20MB)",
    "generateButton": "Generate SOP from Video",
    "uploading": "Uploading...",
    "chooseDifferent": "Choose different file",
    "fileTooLarge": "File too large. Maximum size is 20MB.",
    "unsupportedFormat": "Unsupported format. Please use MP4, WebM, or MOV.",
    "uploadFailed": "Upload failed",
    "uploadTimeout": "Upload timed out. Please check your network and try again.",
    "videoSubmitted": "Video submitted for processing. You will be notified by email when your SOP is ready.",
    "monthlyLimitReached": "Monthly video import limit reached ({{current}}/{{limit}})",
    "upgradeHint": "Upgrade your plan to import more videos."
  },
  "navUser": {
    "profile": "Profile",
    "logOut": "Log out",
    "owner": "Owner",
    "logOutTitle": "Log out of your account?",
    "logOutDesc": "You will need to log back in to access your workspaces."
  },
  "extensionAlert": {
    "title": "Install Extension",
    "description": "Record screens and capture content with ease",
    "getExtension": "Get Extension"
  },
  "feedback": {
    "trigger": "Feedback",
    "ariaLabel": "Send feedback to Tao",
    "title": "Send feedback to Tao",
    "intro1": "Hi, I'm Tao, founder of Glyde. Our team built Glyde because we were tired of writing SOPs nobody reads and onboarding new hires with stale, half-updated docs. We're shipping improvements every week, and your feedback shapes what ships next.",
    "intro2": "Tell me what's broken, confusing, or missing — bugs, ideas, half-baked thoughts, anything. It goes straight to my inbox and I read every message.",
    "placeholder": "What's on your mind?",
    "includeScreenshot": "Include screenshot of this page",
    "capturing": "capturing…",
    "cancel": "Cancel",
    "send": "Send",
    "sending": "Sending…",
    "successToast": "Thanks — Tao will see this.",
    "errorToast": "Failed to send feedback. Try again."
  }
}
